import { BaseController } from '@/api/BaseController';
import { RequestOption } from '@/common/http/types';
import { ANY_OBJECT } from '@/types/generic';
import { TableData } from '@/common/types/table';
import { useUrlBuilder } from '@/common/hooks/useUrl';
import AssetAllocationDetail from '@/types/table/assetAllocationDetail';
import { API_CONTEXT } from '../config';

const { buildGetUrl } = useUrlBuilder();

export interface AssetAllocationDetailData extends AssetAllocationDetail {
  __cascade_add_temp_id__?: string | number | undefined;
}

export default class AssetAllocationDetailController extends BaseController {
  static list(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<AssetAllocationDetailData>>(API_CONTEXT + '/app/assetAllocationDetail/list', params, httpOptions);
  }
  static view(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get<AssetAllocationDetailData>(API_CONTEXT + '/app/assetAllocationDetail/view', params, httpOptions);
  }
  static export(params: ANY_OBJECT, fileName: string) {
    return super.download(API_CONTEXT + '/app/assetAllocationDetail/export', params, fileName);
  }
  static import(params: ANY_OBJECT) {
    return super.upload(API_CONTEXT + '/app/assetAllocationDetail/import', params);
  }
  static printUrl(params: ANY_OBJECT) {
    return buildGetUrl(API_CONTEXT + '/app/assetAllocationDetail/print', params);
  }
  static add(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/assetAllocationDetail/add', params, httpOptions);
  }
  static update(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/assetAllocationDetail/update', params, httpOptions);
  }
  static delete(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/assetAllocationDetail/delete', params, httpOptions);
  }
  static deleteBatch(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/assetAllocationDetail/deleteBatch', params, httpOptions);
  }

  static getUserInformation(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<AssetAllocationDetailData>>(API_CONTEXT + '/app/dept/getUserInformation', params, httpOptions);
  }
}
